import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import { useRouter } from 'next/router';
import React from 'react';

import pageUrls from 'constants/pagesUrls';

import ALink from 'components/basic/ALink';
import Icon, { IconTypes } from 'components/basic/Icon';

import s from './Footer.module.scss';

const Footer: React.FC<{ className: string }> = () => {
  const router = useRouter();
  const t = useTranslationAndTypograph();
  const isCompact = !!router.query.compact;

  function logStoreLinkClick(type: string): void {
    logEvent('Web_Footer_Store_Button_Clicked ', { type });
  }

  function boringLinkClick(link_id: string): void {
    logEvent('Web_Footer_Legal_Link_Clicked ', { link_id });
  }

  function socialLinkClick(button_id: string): void {
    logEvent('Web_Footer_Social_Logo_Clicked ', { button_id });
  }

  if (isCompact) {
    return null;
  }

  return (
    <footer className={s.wrapper}>
      <div className={s.leftWrapper}>
        <div className={s.text}> {t('Download Welltory mobile app')}</div>
        <div className={s.storeLinksWrapper}>
          <ALink
            className={s.storeLink}
            href="https://welltory.onelink.me/ZNvo/footer"
            target="_blank"
            onClick={(): void => {
              logStoreLinkClick('AppStore');
            }}
          >
            <Icon icon={IconTypes.apple} size={48} />
          </ALink>
          <ALink
            className={s.storeLink}
            href="https://welltory.onelink.me/k5vK/footer"
            target="_blank"
            onClick={(): void => {
              logStoreLinkClick('Google Play');
            }}
          >
            <Icon icon={IconTypes.googlePlay} size={48} />
          </ALink>
        </div>
      </div>
      <div className={s.rightWrapper}>
        <div className={s.boringLinksWrapper}>
          <ALink
            className={cn(s.text, s.storeLink, 'cy-footer-terms-link')}
            href={pageUrls.terms}
            onClick={(): void => {
              boringLinkClick('terms');
            }}
          >
            {t('Terms of Use')}
          </ALink>
          <span className={cn(s.text, s.divider)}>|</span>
          <ALink
            className={cn(s.text, s.storeLink, 'cy-footer-privacy-link')}
            href={pageUrls.privacy}
            onClick={(): void => {
              boringLinkClick('privacy');
            }}
          >
            {t('Privacy Policy')}
          </ALink>
        </div>
        <div className={s.socialsWrapper}>
          <ALink
            target="_blank"
            href="https://twitter.com/welltory/"
            className={s.socialLink}
            onClick={(): void => {
              socialLinkClick('twitter');
            }}
          >
            <Icon icon={IconTypes.twitter} size={32} />
          </ALink>
          <ALink
            target="_blank"
            href="https://www.facebook.com/welltory/"
            className={s.socialLink}
            onClick={(): void => {
              socialLinkClick('facebook');
            }}
          >
            <Icon icon={IconTypes.facebook} size={32} />
          </ALink>
          <ALink
            target="_blank"
            href="https://www.instagram.com/welltory/"
            className={s.socialLink}
            onClick={(): void => {
              socialLinkClick('instagram');
            }}
          >
            <Icon icon={IconTypes.instagram} size={32} />
          </ALink>
          <ALink
            target="_blank"
            href="https://www.linkedin.com/company/welltory/"
            className={s.socialLink}
            onClick={(): void => {
              socialLinkClick('linkedin');
            }}
          >
            <Icon icon={IconTypes.linkedin} size={32} />
          </ALink>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
